import GradientBorderRadius from "@/ui/gradient-border-radius";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { FC } from "react";

const Pagination: FC<{
  page: number;
  perPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  onNextPage: () => void;
  onPreviousPage: () => void;
  label: string;
}> = ({
  page = 1,
  perPage = 100,
  hasNextPage = true,
  hasPreviousPage = false,
  onNextPage,
  onPreviousPage,
  label,
}) => {
  return (
    <div className="w-full h-fit flex justify-center items-center gap-[1rem] py-[0.5rem]">
      {hasPreviousPage && (
        <div>
          <GradientBorderRadius radius="circle" hover="r-100">
            <button
              onClick={onPreviousPage}
              className="gap-[0.5rem] p-[0.5rem] text-white bg-[#050708] hover:bg-[#050708]/90 focus:ring-4 focus:outline-none focus:ring-[#050708]/50 font-medium rounded-full inline-flex items-center dark:focus:ring-[#050708]/50 dark:hover:bg-[#050708]/30"
            >
              <ChevronLeftIcon className="w-[0.75rem] h-[0.75rem]" />
            </button>
          </GradientBorderRadius>
        </div>
      )}
      <div>
        {label}&nbsp;{(page - 1) * perPage + 1}&nbsp;-&nbsp;
        {(page - 1) * perPage + perPage}
      </div>
      {hasNextPage && (
        <div>
          <GradientBorderRadius radius="circle" hover="r-100">
            <button
              onClick={onNextPage}
              className="gap-[0.5rem] p-[0.5rem] text-white bg-[#050708] hover:bg-[#050708]/90 focus:ring-4 focus:outline-none focus:ring-[#050708]/50 font-medium rounded-full inline-flex items-center dark:focus:ring-[#050708]/50 dark:hover:bg-[#050708]/30"
            >
              <ChevronRightIcon className="w-[0.75rem] h-[0.75rem]" />
            </button>
          </GradientBorderRadius>
        </div>
      )}
    </div>
  );
};

export default Pagination;
